// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"389":"8009503d","752":"7b028b69"}[chunkId] + ".css";
};